import React, { useEffect, useState } from "react";
import Container from "components/container";
import ContentContainer from "components/content-container";
import { Link, useParams } from "react-router-dom";
import LoadingComponent from "components/loading-component";
import Text from "components/text";
import CompanyAdmin from "pages/company-admin";
import styles from "./contractor-submittal.module.css";
import { SidePanelSubmittalsService } from "apis/Services/SidePanelSubmittalsService";
import { CaretRightOutlined, FlagFilled } from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Collapse,
  Result,
  Tooltip,
  Tabs,
  Tag,
  Empty,
  Modal,
  Input,
  Affix,
} from "antd";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import Submittal from "./submittal";
import { ProjectServices } from "apis/Services/ProjectService";

const { Panel } = Collapse;

const SidePanelSubmittals = ({}) => {
  const [companyId, setCompanyId] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [resourceId, setResourceId] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [submittals, setSubmittals] = useState();
  const [workingDays, setWorkingDays] = useState();
  const [nonWorkingDays, setNonWorkingDays] = useState();
  const [itemsPendingApprovals, setItemsPendingApprovals] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [scheduleIDsList, setScheduleIDsList] = useState([]);

  const [changedEntries, setChangedEntries] = useState({});

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newSubmittalTitle, setNewSubmittalTitle] = useState("");
  const [tempSubmittal, setTempSubmittal] = useState(null);

  const [companyName, setCompanyName] = useState("");
  const [projectName, setProjectName] = useState("");

  const [filter, setFilter] = useState("");

  const [reviewTime, setReviewTime] = useState("");
  const [approvalTime, setApprovalTime] = useState("");

  useEffect(() => {
    console.log("=== PROCORE INTEGRATION STARTING ===");
    console.log("Document referrer:", document.referrer);
    console.log("Window location:", window.location.href);

    // Message event listener
    const handleMessage = (event) => {
      console.log("=== MESSAGE EVENT RECEIVED ===");
      console.log("Event origin:", event.origin);
      console.log("Event data:", event.data);
      console.log("Event type:", typeof event.data);

      try {
        const obj = event.data;
        console.log("Message object:", obj);
        console.log("Message type:", obj.type);

        if (obj.type === "setup") {
          console.log("🚀 SETUP MESSAGE RECEIVED!");

          // Extract context data
          const company_id = obj.context?.company_id;
          const project_id = obj.context?.project_id;
          const view = obj.context?.view;
          const resource_id = obj.context?.id;

          console.log("=== PROCORE CONTEXT DATA ===");
          console.log("Company ID:", company_id);
          setCompanyId(company_id);
          console.log("Project ID:", project_id);
          setProjectId(project_id);
          console.log("View:", view);
          console.log("Resource ID:", resource_id);
          setResourceId(resource_id);
          console.log("Full context:", obj.context);

          // Send acknowledgment back to Procore
          console.log("📤 Sending acknowledgment to Procore");
          event.source.postMessage({ type: "acknowledge" }, event.origin);
        } else {
          console.log("ℹ️ Non-setup message received:", obj.type);
        }
      } catch (error) {
        console.error("❌ Error processing message:", error);
        console.error("Raw event data:", event.data);
      }
    };

    // Register the message listener
    window.addEventListener("message", handleMessage);
    console.log("✅ Message listener registered");

    // Initialize communication with Procore based on document.referrer
    // The key issue was likely here - you need to check the exact referrer format
    console.log("🔍 Checking document.referrer for initialization...");

    const referrer = document.referrer;
    console.log("Full referrer:", referrer);

    // Check each region and send initialize message
    if (referrer.startsWith("https://app.procore.com/")) {
      console.log("📤 Sending initialize to app.procore.com");
      window.parent.postMessage(
        { type: "initialize" },
        "https://app.procore.com"
      );
    } else if (referrer.startsWith("https://us02.procore.com/")) {
      console.log("📤 Sending initialize to us02.procore.com");
      window.parent.postMessage(
        { type: "initialize" },
        "https://us02.procore.com"
      );
    } else if (referrer.startsWith("https://uk01.procore.com/")) {
      console.log("📤 Sending initialize to uk01.procore.com");
      window.parent.postMessage(
        { type: "initialize" },
        "https://uk01.procore.com"
      );
    } else {
      console.log(
        "❌ Document referrer doesn't match any known Procore domains"
      );
      console.log("Referrer was:", referrer);

      // Fallback: try to send initialize to all regions
      console.log("🔄 Attempting fallback initialization...");
      try {
        window.parent.postMessage(
          { type: "initialize" },
          "https://app.procore.com"
        );
        window.parent.postMessage(
          { type: "initialize" },
          "https://us02.procore.com"
        );
        window.parent.postMessage(
          { type: "initialize" },
          "https://uk01.procore.com"
        );
      } catch (error) {
        console.error("❌ Fallback initialization failed:", error);
      }
    }

    // Cleanup function
    return () => {
      console.log("🧹 Cleaning up message listener");
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  let company_id = companyId;
  let id = projectId;
  let entryID = resourceId;
  let email = localStorage.getItem("email");
  let code = localStorage.getItem("token");
  // let email = "ahesham@koncurent.com";

  const getSubmittals = async () => {
    let requestData = {
      company_id,
      id,
      entryID,
      email,
      code,
    };

    // console.log(requestData);

    try {
      const res =
        await SidePanelSubmittalsService.procurementLogReadSpecificSubmittalSidePanel(
          requestData
        );

      console.log(res);
      setSubmittals(res?.content);
      // setCompanyName(company_name);
      // setProjectName(project_name);
      setWorkingDays(res.workingDays);
      setNonWorkingDays(res.nonWorkingDays);
      setScheduleIDsList(res.schedule);
      setApprovalTime(res.approvalTime);
      setReviewTime(res.reviewTime);

      console.log(res?.content);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to determine if an entry is new
  const isNewEntry = (entry) => {
    return (
      entry.isNew === "true" || entry.entryID.toString().startsWith("new-")
    );
  };

  // Helper function to separate new and edited entries
  const categorizeChanges = (changedEntries) => {
    const newEntries = [];
    const editedEntries = [];

    Object.values(changedEntries).forEach((entry) => {
      if (isNewEntry(entry)) {
        // For new entries, we set the entryID to empty string as required by the API
        const entryCopy = { ...entry };
        entryCopy.entryID = ""; // Set to empty for API submission
        newEntries.push(entryCopy);
      } else {
        editedEntries.push(entry);
      }
    });

    return { newEntries, editedEntries };
  };

  function recalculateDate() {
    const code = localStorage.getItem("token");
    const loginEmail = localStorage.getItem("email");

    const updateBackEndData = {
      company: company_id,
      project: id,
      code,
      loginEmail,
      approvalTime: approvalTime,
      reviewTime: reviewTime,
    };

    ProjectServices.getExportData(updateBackEndData);
  }

  const handleSubmitAll = async () => {
    console.log("Changed entries:", changedEntries);

    if (Object.keys(changedEntries).length === 0) {
      return;
    }

    // Get authentication data
    let code = localStorage.getItem("token");
    let loginEmail = localStorage.getItem("email");

    // Categorize changes into new and edited entries
    const { newEntries, editedEntries } = categorizeChanges(changedEntries);

    // Helper function to format entry data for API requests
    const formatEntryData = (entry, isNew = false) => ({
      entryID: isNew ? "" : entry.entryID,
      specSection: entry.specSection || "",
      specNumber: entry.specNumber || "",
      specTitle: entry.specTitle || "",
      specRevision: entry.specRevision || "",
      specType: entry.specType || "",
      specResponse: entry.specResponse || "",
      responsibleContractor: entry.responsibleContractor || "",
      issueContract: entry.issueContract || "",
      contractIssuedRelease: entry.contractIssuedRelease || "",
      submittalPrepTime: String(entry.submittalPrepTime || ""),
      submittalRequired: entry.submittalRequired || "",
      submittalIssued: entry.submittalIssued || "",
      approvalTime: String(entry.approvalTime || ""),
      submittalApprovalDue: entry.submittalApprovalDue || "",
      submittalReturned: entry.submittalReturned || "",
      leadTime: String(entry.leadTime || ""),
      scheduleID: entry.scheduleID || "",
      dateRequiredOnSite: entry.dateRequiredOnSite || "",
      subCommittedDeliveryDate: entry.subCommittedDeliveryDate || "",
      projectedDeliveryDate: entry.projectedDeliveryDate || "",
      ActualDeliveryDate: entry.actualDeliveryDate || "",
      custom1: entry.custom1 || "",
      custom2: entry.custom2 || "",
      custom3: entry.custom3 || "",
      custom4: entry.custom4 || "",
      custom5: entry.custom5 || "",
      custom6: entry.custom6 || "",
      custom7: entry.custom7 || "",
      custom8: entry.custom8 || "",
      custom9: entry.custom9 || "",
      custom10: entry.custom10 || "",
      custom11: entry.custom11 || "",
      custom12: entry.custom12 || "",
      custom13: entry.custom13 || "",
      custom14: entry.custom14 || "",
      custom15: entry.custom15 || "",
      custom16: entry.custom16 || "",
      custom17: entry.custom17 || "",
      custom18: entry.custom18 || "",
      custom19: entry.custom19 || "",
      custom20: entry.custom20 || "",
      custom21: entry.custom21 || "",
      custom22: entry.custom22 || "",
      custom23: entry.custom23 || "",
      custom24: entry.custom24 || "",
      custom25: entry.custom25 || "",
      entryOrigin: entry.entryOrigin || "Koncurent",
      criticalPathFlag: entry.criticalPathFlag || "False",
    });

    // Format data for API requests
    let addRowsData = newEntries.map((entry) => formatEntryData(entry, true));
    let editRowsData = editedEntries.map((entry) =>
      formatEntryData(entry, false)
    );

    // Authentication data for API requests
    let authData = {
      company_id,
      project_id: id,
      code,
      loginEmail,
    };

    setIsLoading(true);
    try {
      if (addRowsData.length > 0) {
        const addRes = await ProjectServices.addRow(addRowsData, authData);
        console.log("Add API response:", addRes);
      }

      // Handle edited entries
      if (editRowsData.length > 0) {
        const editRes = await ProjectServices.EditRow(editRowsData, authData);
        console.log("Edit API response:", editRes);
      }

      // Clear changedEntries after successful submission

      // Refresh submittals data
      setChangedEntries({});
      recalculateDate();
      getSubmittals();
    } catch (err) {
      console.error("Error submitting changes:", err);
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    getSubmittals();
  }, []);

  const SUBMITTAL_TEMPLATE = {
    entryID: "",
    specSection: "",
    specNumber: "",
    specTitle: "",
    specRevision: "",
    specType: "",
    specResponse: "",
    responsibleContractor: "",
    issueContract: "",
    contractIssuedRelease: "",
    submittalPrepTime: "2",
    submittalRequired: "",
    submittalIssued: "",
    approvalTime: "2",
    submittalApprovalDue: "",
    submittalReturned: "",
    leadTime: "2",
    scheduleID: "",
    dateRequiredOnSite: "",
    projectedDeliveryDate: "",
    subCommittedDeliveryDate: "",
    actualDeliveryDate: "",
    custom1: "",
    custom2: "",
    custom3: "",
    custom4: "",
    custom5: "",
    custom6: "",
    custom7: "",
    custom8: "",
    custom9: "",
    custom10: "",
    custom11: "",
    custom12: "",
    custom13: "",
    custom14: "",
    custom15: "",
    custom16: "",
    custom17: "",
    custom18: "",
    custom19: "",
    custom20: "",
    custom21: "",
    custom22: "",
    custom23: "",
    custom24: "",
    custom25: "",
    entryOrigin: "Koncurent",
    assignedUserNames: [],
    assignedEmails: [],
    criticalPathFlag: "False",
    isNew: "true",
  };

  const handleAddItem = () => {
    if (!tempSubmittal || !newSubmittalTitle.trim()) return;

    console.log("Adding submittal with all changes:", tempSubmittal);

    // Create the final version with the title
    const finalSubmittal = {
      ...tempSubmittal,
      specTitle: newSubmittalTitle,
    };

    // Add to the list of submittals
    setSubmittals((prev) => [...prev, finalSubmittal]);

    // Track the changes for saving
    setChangedEntries((prev) => ({
      ...prev,
      [finalSubmittal.entryID]: finalSubmittal,
    }));

    // Reset state
    setIsModalVisible(false);
    setTempSubmittal(null);
  };

  const showAddItemModal = () => {
    setNewSubmittalTitle("");

    const lastSubmittal =
      submittals.length > 0 ? submittals[submittals.length - 1] : {};
    const tempEntryID = `new-${Date.now()}`;

    // Create a new submittal with defaults
    const newTemp = {
      ...SUBMITTAL_TEMPLATE,
      entryID: tempEntryID,
      specSection: lastSubmittal?.specSection || "",
      specNumber: lastSubmittal?.specNumber || "",
      specRevision: lastSubmittal?.specRevision || "",
      specTitle: "", // Will be set from newSubmittalTitle
    };

    // Set the temp submittal
    setTempSubmittal(newTemp);
    setIsModalVisible(true);
  };

  // Get delivery status based on dates
  const getDeliveryStatus = (data) => {
    let actual = data.actualDeliveryDate;
    let required = data.dateRequiredOnSite;
    const currentDate = new Date();

    if (!required) {
      return "";
    }

    if (!(required instanceof Date)) {
      required = new Date(required);
    }

    if (actual && !(actual instanceof Date)) {
      actual = new Date(actual);
    }

    if (actual) {
      return "Delivered";
    }

    let timeDifference = required.getTime() - currentDate.getTime();
    let numOfDays = Math.floor(timeDifference / (1000 * 3600 * 24)); // milliseconds to days

    if (numOfDays < 0) {
      return "Late";
    } else if (numOfDays < 7) {
      return "Approaching Deadline";
    } else {
      return "";
    }
  };

  // Get style for delivery status
  const getStatusStyle = (status) => {
    switch (status) {
      case "Delivered":
        return {
          color: "#1D9534", // Green
          backgroundColor: "#e6f7ea",
        };
      case "Late":
        return {
          color: "#E60200", // Red
          backgroundColor: "#ffe6e6",
        };
      case "Approaching Deadline":
        return {
          color: "#FF9900", // Orange/Yellow
          backgroundColor: "#fff2e6",
        };
      default:
        return {
          display: "none",
        };
    }
  };

  const scheduleOptions = React.useMemo(() => {
    const tempOptions = [
      ...scheduleIDsList.map((x) => ({
        label: Object.keys(x)[0] + " - " + Object.values(x)[0]["taskName"],
        value: Object.keys(x)[0],
      })),
    ];
    const options = tempOptions.sort((a, b) => +a.value - +b.value);

    return options;
  }, [scheduleIDsList]);

  return (
    <Container>
      {/* <div className=" d-flex justify-content-center align-items-center mt-4">
        <h3 className=" fw-bold">Submittals</h3>
      </div> */}

      <ContentContainer className="px-3 py-1 my-4">
        {!isLoading ? (
          <div className="my-4">
            <div className=" d-flex justify-content-between mb-4">
              <Text className={`${styles.title}`}>{projectName}</Text>
              <Text className={`${styles.title}`}>{companyName}</Text>
            </div>
            <>
              <Affix offsetTop={0} onChange={(affixed) => console.log(affixed)}>
                <div className="w-100 d-flex justify-content-between mb-3 bg-white shadow-sm p-2 rounded-2">
                  <Button type="primary" onClick={showAddItemModal}>
                    Add Item
                  </Button>

                  <Button
                    type="primary"
                    disabled={Object.keys(changedEntries).length === 0}
                    onClick={handleSubmitAll}
                  >
                    Save Changes
                  </Button>
                </div>
              </Affix>
              {submittals?.map((item, index) => {
                const deliveryStatus = getDeliveryStatus(item);
                const statusStyle = getStatusStyle(deliveryStatus);

                return (
                  <Collapse
                    className={`my-2 ${styles.panelStyling}`}
                    key={index}
                    ghost
                    expandIconPosition="start"
                    expandIcon={({ isActive }) => (
                      <CaretRightOutlined rotate={isActive ? 90 : 0} />
                    )}
                  >
                    <Panel
                      header={
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className=" d-flex align-items-center gap-2">
                            <span>
                              {item?.specTitle || "Unnamed Submittal"}
                            </span>

                            {item.criticalPathFlag === "True" && (
                              <Tooltip title="Critical Path">
                                <FlagFilled style={{ fontSize: "0.8rem" }} />
                              </Tooltip>
                            )}
                          </div>

                          <div>
                            {deliveryStatus && (
                              <span
                                style={{
                                  ...statusStyle,
                                  padding: "0.2rem 0.5rem",
                                  borderRadius: "5px",
                                  fontSize: "0.8rem",
                                }}
                              >
                                {deliveryStatus}
                              </span>
                            )}
                          </div>
                        </div>
                      }
                      key="1"
                    >
                      <Submittal
                        submittal={item}
                        workingDays={workingDays}
                        nonWorkingDays={nonWorkingDays}
                        scheduleIDsList={scheduleIDsList}
                        scheduleOptions={scheduleOptions}
                        onChange={(changedItem) => {
                          setChangedEntries((prev) => ({
                            ...prev,
                            [changedItem.entryID]: changedItem,
                          }));
                        }}
                        deliveryStatus={deliveryStatus}
                      />
                    </Panel>
                  </Collapse>
                );
              })}
            </>

            <Modal
              title="Enter submittal name"
              open={isModalVisible}
              onOk={handleAddItem}
              onCancel={() => setIsModalVisible(false)}
              okButtonProps={{ disabled: !newSubmittalTitle.trim() }}
            >
              <div className="mb-3">
                <label>Submittal Name:</label>
                <Input
                  type="text"
                  value={newSubmittalTitle}
                  onChange={(e) => setNewSubmittalTitle(e.target.value)}
                  placeholder="Enter submittal name"
                  className="mb-3"
                />
              </div>

              {tempSubmittal && (
                <div className="border rounded p-2">
                  <Submittal
                    submittal={tempSubmittal}
                    workingDays={workingDays}
                    nonWorkingDays={nonWorkingDays}
                    scheduleIDsList={scheduleIDsList}
                    scheduleOptions={scheduleOptions}
                    onChange={(updatedSubmittal) => {
                      console.log("Submittal changed:", updatedSubmittal);
                      // This is crucial - directly update the full tempSubmittal object
                      setTempSubmittal(updatedSubmittal);
                    }}
                    deliveryStatus=""
                  />
                </div>
              )}
            </Modal>
          </div>
        ) : (
          <div className="my-4">
            <LoadingComponent />
          </div>
        )}
      </ContentContainer>
    </Container>
  );
};

export default SidePanelSubmittals;
